import React, { FC } from 'react'

import { ProductChartMatchTable } from 'modules/ProductChartMatches/components'

import { NoItems } from 'components'

import { useProductChartMatch } from '../serviceHooks/useProductChartMatch'

const ProductChartMatchListContainer: FC = () => {

  const { confirmProductChartMatch, productChartMatchList } = useProductChartMatch()

  return (
    productChartMatchList?.length ? 
      <ProductChartMatchTable 
        productChartMatchList={productChartMatchList} 
        onConfirmProductChartMatch={confirmProductChartMatch} 
      /> : <NoItems name="Product Chart Matches" />
  )
}

export default ProductChartMatchListContainer
